import React from 'react';
import { EngineRenderers } from '../../../../../../../renderProps';
import PriceDetailsRoot from '../../ExchangeRefundPriceDetails';

const PriceDetailsShortVariant: EngineRenderers['PriceDetails'] = props => {
	return <PriceDetailsRoot {...props} variant="short-details" />;
};

export default PriceDetailsShortVariant;
